namespace TabAurous.SalesOrder {
    export namespace OrderItemsForStockAllocationService {
        export const baseUrl = 'SalesOrder/OrderItemsForStockAllocation';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/OrderItemsForStockAllocation/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderItemsForStockAllocationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
